import React from 'react';
import UserProfileWidget from './community/UserProfileWidget';
import ProfileEfficacyWidget from './community/ProfileEfficacyWidget';
import AIProfileSuggestionsWidget from './community/AIProfileSuggestionsWidget';
import GroupFeedWidget from './community/GroupFeedWidget';
const CommunityDashboard = () => {
  return <div className="space-y-4" data-id="element-775">
      {/* First row - Profile widgets */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-776">
        <div className="col-span-1" data-id="element-777">
          <UserProfileWidget data-id="element-778" />
        </div>
        <div className="col-span-1" data-id="element-779">
          <ProfileEfficacyWidget data-id="element-780" />
        </div>
        <div className="col-span-1" data-id="element-781">
          <AIProfileSuggestionsWidget data-id="element-782" />
        </div>
      </div>

      {/* Second row - Feed widget (full width now since match widget is gone) */}
      <div className="grid grid-cols-1 gap-4" data-id="element-783">
        <div className="col-span-1" data-id="element-784">
          <GroupFeedWidget data-id="element-785" />
        </div>
      </div>
    </div>;
};
export default CommunityDashboard;